import { api } from "./client";

export async function login({ email, password }) {
  const resp = await api.post("/auth/login", {
    email,
    password,
  });

  const token = resp?.data?.access_token;
  const user = resp?.data?.user;

  if (!token) {
    throw new Error("Login succeeded but no access_token was returned.");
  }

  if (!user) {
    throw new Error("Login succeeded but no user object was returned.");
  }

  return { token, user };
}

export async function register({ email, password, username }) {
  const resp = await api.post("/auth/register", {
    email,
    password,
    username,
  });

  return resp.data;
}

export async function requestPasswordReset({ email }) {
  const resp = await api.post("/auth/forgot-password", {
    email,
  });

  return resp.data;
}

export async function resetPassword({ token, new_password }) {
  const resp = await api.post("/auth/reset-password", {
    token,
    new_password,
  });

  return resp.data;
}

export async function changePassword({ current_password, new_password }) {
  const resp = await api.post("/auth/change-password", {
    current_password,
    new_password,
  });

  return resp.data;
}

export async function getMe() {
  const resp = await api.get("/auth/me");
  return resp.data;
}

export async function updateMe({
  email,
  username,
  preferred_payment_method,
  payment_handle,
}) {
  const resp = await api.put("/auth/me", {
    email,
    username,
    preferred_payment_method,
    payment_handle,
  });

  return resp.data;
}